import React from "react";
import {
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Checkbox,
  Tooltip, 
  Button
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  AccessTime as AccessTimeIcon,
  Height as HeightIcon
} from "@mui/icons-material";
import SelectInput from "../SelectInput";
import { GenerateAgeOptions, MAX_AGE, MIN_AGE } from "../../constants/profileData";
import HeightFilter from "./HeightFilter";
import { SELECT_ALL_FILTER } from "../../constants/filters";

export const FilterOptionsRenderer=({
    toggleFilterExpand, 
    expandedFilter, 
    filterState, 
    setFilterState,
    getFilterIcon,
    searchQuery,
    handleSearchChange,
    handleCheckboxChange, 
    applyProfileFilter,
    resetFilters
})=>{
    return (
        <>
            <div style={{ marginTop: 10 }}>
                <Tooltip title="Click 'Apply' to apply selected filters">
                    <Button style={{ marginRight: 10 }} onClick={() => applyProfileFilter()} variant="contained">
                        Apply
                    </Button>
                </Tooltip>
                <Tooltip title="Click 'Apply' after resetting filters">
                    <Button onClick={resetFilters} variant="contained">
                        Clear filters
                    </Button>
                </Tooltip>
            </div>
            <p className="mt-8 mb-3 font-medium text-lg">Filter Options</p>
            <List>
                {/* Age Filter Section */}
                <ListItemButton onClick={() => toggleFilterExpand("ageFilterState")}>
                <ListItemIcon>
                    <AccessTimeIcon />
                </ListItemIcon>
                <ListItemText primary="Age" />
                {expandedFilter["ageFilterState"] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={expandedFilter["ageFilterState"]} timeout="auto">
                    <Box p={2} display="flex" alignItems="center" gap={2}>                        
                        <SelectInput
                            name="minAge"
                            label="Min Age"
                            value={filterState.ageFilterState[0].toString()} // Convert to string for Select
                            handleChange={(event) => {
                                const value = Number(event.target.value);
                                setFilterState({
                                    ...filterState,
                                    ageFilterState: [value, filterState.ageFilterState[1]],
                                });
                            }}
                            options={GenerateAgeOptions(MIN_AGE, filterState.ageFilterState[1]-1)}
                        />

                        <SelectInput
                            name="maxAge"
                            label="Max Age"
                            value={filterState.ageFilterState[1].toString()} // Convert to string for Select
                            handleChange={(event) => {
                                const value = Number(event.target.value);
                                setFilterState({
                                    ...filterState,
                                    ageFilterState: [filterState.ageFilterState[0], value],
                                });
                            }}
                            options={GenerateAgeOptions(filterState.ageFilterState[0]+1, MAX_AGE)}
                        />
                    </Box>
                </Collapse>
                {/* Height Filter Section */}
                <ListItemButton onClick={() => toggleFilterExpand("heightFilterState")}>
                <ListItemIcon>
                    <HeightIcon />
                </ListItemIcon>
                <ListItemText primary="Height" />
                {expandedFilter["heightFilterState"] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={expandedFilter["heightFilterState"]} timeout="auto">
                    <HeightFilter filterState={filterState} setFilterState={setFilterState} />
                </Collapse>

                {/* General structure for checkbox filter sections */}
                {Object.keys(filterState).map((filterKey) => {
                if (filterKey === "ageFilterState"  || filterKey === 'heightFilterState') return null; // Skip age and height since it uses Slider
                const filterLabel = filterState[filterKey].filterName;
                const currentFilter = filterState[filterKey];
                const filteredOptions = filterState[filterKey].filters.filter((item) => item.label?.toLowerCase().includes((searchQuery[filterKey] || "")?.toLowerCase()));
                return (
                    <React.Fragment key={filterKey}>
                    <ListItemButton onClick={() => toggleFilterExpand(filterKey)}>
                        <ListItemIcon>{getFilterIcon(filterKey)}</ListItemIcon>
                        <ListItemText primary={filterLabel} />
                        {expandedFilter[filterKey] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={expandedFilter[filterKey]} timeout="auto">
                        <Box p={2}>
                        <TextField
                            variant="outlined"
                            label={`Search ${filterLabel}`}
                            fullWidth
                            size="small"
                            value={searchQuery[filterKey] || ""}
                            onChange={(e) => handleSearchChange(filterKey, e.target.value)}
                        />
                        <div style={{ maxHeight: 200, overflowY: "auto", marginTop: 10 }}>
                            {
                                // Select all checkbox
                                currentFilter.enableSelectAll && (
                                    <div key={`${filterKey}-selectall`} style={{ display: "flex", alignItems: "center" }}>
                                        <Checkbox
                                            checked={currentFilter.selectedCount === currentFilter.filters.length}
                                            onChange={() => handleCheckboxChange(filterKey, SELECT_ALL_FILTER)}
                                        />
                                        <ListItemText primary={SELECT_ALL_FILTER} />
                                    </div>
                                )
                            }
                            {filteredOptions.map((option) => (
                                <div key={option.label} style={{ display: "flex", alignItems: "center" }}>
                                    <Checkbox
                                        checked={option.checked}
                                        onChange={() => handleCheckboxChange(filterKey, option)}
                                    />
                                    <ListItemText primary={option.label} />
                                </div>
                            ))}
                        </div>
                        </Box>
                    </Collapse>
                    </React.Fragment>
                );
                })}
            </List>
        </>
    )
}